import { useMutation } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { Recipient } from '../../../../types';
import { DocumentParams } from '../../../documents/types/DocumentParams';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { applyTemplateRoleContact } from '../../requests/applyTemplateRoleContact';

type ApplyTemplateRoleContactVariables = {
  roleId: string;
  documentParams: DocumentParams<'definition'>;
  params?: RequestConfig['params'];
};

export const useApplyTemplateRoleContact = () => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    Recipient | undefined,
    Error,
    ApplyTemplateRoleContactVariables
  >({
    mutationFn: ({ roleId, documentParams, params }) =>
      applyTemplateRoleContact(
        constructGet,
        roleId,
        documentParams,
        params,
      ).then((response) => response?.data),
  });

  return { applyTemplateRoleContact: mutateAsync, ...rest };
};
